import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioCreateCreditRechargeRequestDto,
  NuvemEnvioCreateCreditRechargeResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioCreditRechargeLabelsData,
  getNuvemEnvioCreditRechargeLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  creditRechargeNuvemEnvioLabels as creditRechargeNuvemEnvioLabelsAction,
  resetNuvemEnvioLabels as resetNuvemEnvioLabelsAction,
} from '../../ordersSlice/ordersSlice';

export interface UseCreditRechargeNuvemEnvioLabelsResult {
  createNuvemEnvioRecharge: (
    labels: NuvemEnvioCreateCreditRechargeRequestDto,
  ) => Promise<NuvemEnvioCreateCreditRechargeResponseDto>;
  resetNuvemEnvioLabels: () => void;
  data: NuvemEnvioCreateCreditRechargeResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
}

function useCreditRechargeNuvemEnvioLabels(): UseCreditRechargeNuvemEnvioLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioCreditRechargeLabelsData);
  const status = useSelector(getNuvemEnvioCreditRechargeLabelsStatus);

  const createNuvemEnvioRecharge = useCallback(
    async (
      labels: NuvemEnvioCreateCreditRechargeRequestDto,
    ): Promise<NuvemEnvioCreateCreditRechargeResponseDto> => {
      const response = await dispatch(
        creditRechargeNuvemEnvioLabelsAction({
          amount: labels.amount,
          fulfillmentOrderIds: labels.fulfillmentOrderIds,
        }),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetNuvemEnvioLabels = useCallback(() => {
    dispatch(resetNuvemEnvioLabelsAction());
  }, [dispatch]);

  return {
    createNuvemEnvioRecharge,
    resetNuvemEnvioLabels,
    data,
    status,
  };
}

export default useCreditRechargeNuvemEnvioLabels;
